import { createSelector } from 'reselect';

import { AppState } from '../../reducers/root.reducer';

const questionnaire = (state: AppState) => state.questionnaire;

const isLoading = createSelector(
    questionnaire,
    (questionnaire) => questionnaire.loading,
);

const QuestionnaireSelectors = {
    isLoading,
};

export default QuestionnaireSelectors;
